import { useLocation } from 'react-router-dom';
import { DailyDto } from 'src/api/FiretrolApiClient';
import { Header } from 'src/design/organisms/Header';
import { DailyForm } from './components/DailyForm';

const initialValues: DailyDto = {
  id: '00000000-0000-0000-0000-000000000000',
  jobId: -1,
  date: new Date(),
  status: 'Working',
  description: '',
  weather: null,
  questions: [],
  workTicketIdsToAdd: [],
  workTicket: [],
  attachment: [],
  attachmentsToAdd: [],
  attachmentsToRemove: [],
  dailyProgressItem: [],
  progressItemRequests: [],
  progressItemIds: [],
  excludeImages: false,
  excludeTickets: true,
  excludeTimesheets: false,
  excludeQuestions: false,
  excludeProgress: false,
};

export const Daily = () => {
  const location = useLocation();
  const init = location.state?.job
    ? {
        ...initialValues,
        jobId: location.state.job.id,
      }
    : initialValues;
  return (
    <>
      <Header
        title="Create Daily"
        breadcrumbProps={{
          items: [
            { text: 'Operations', href: '/operations' },
            { text: 'Daily' },
          ],
        }}
        helpText="Create a daily report for a job"
      />
      <DailyForm
        initialValues={init}
        initialJob={location.state?.job || null}
      />
    </>
  );
};
